<script lang="typescript">
    import LensDetail from "./LensDetail.svelte";
    import { variantImages } from "../appData.js";
    import { logoImages } from "../appData.js";
    import { state } from "../stores.js";
    import { isChildrenLens } from "../utils.js";

    let images = variantImages.transitions;
    if (isChildrenLens($state)) {
        images = variantImages.adaptiveBoy;
    }
</script>

<LensDetail logo={logoImages.transitions} {images}>
    <div>
        <ul>
            <li>Lenses that change colour from indoor to outdoor</li>
            <li>
                The fastest reacting lens, activating in seconds outdoors and returning to fully
                clear indoors
            </li>
            <li>
                Lenses provide 100% UVA and UVB Protection – this means you don’t need to carry a
                pair of glasses and sunglasses
            </li>
            <li>Designed to wear every day</li>
            <li>Filtering blue - violet light indoor and outdoors</li>
        </ul>
    </div>
    <div>
        <h2>Who is it suitable for?</h2>
        <ul>
            {#if isChildrenLens($state)}
                <li>Someone that spends time indoors and outdoors, including students</li>
            {:else}
                <li>Both adults and children</li>
                <li>Someone that spends time indoors and outdoors</li>
                <li>Occupations may include: students, builders, gardeners, postperson</li>
            {/if}
        </ul>
    </div>
</LensDetail>
